import { LOCALE_HEADER } from '@/configurations/i18n/transport';

/**
 * Ajoute le header de locale à un appel `/api/**`.
 *
 * Fonction pure plutôt que hook, pour les call sites hors composant (soumission
 * du panier). Dans un composant, préférer `useApiFetch()`, qui lit la locale du
 * contexte next-intl.
 *
 * Les headers de l'appelant passent par `new Headers()` et NON par un spread
 * d'objet : `RequestInit.headers` accepte aussi une instance `Headers` et un
 * tableau de tuples, que `{ ...init.headers }` réduirait à `{}`. Comme
 * `useApiFetch()` est typé `typeof fetch`, ces deux formes sont légitimes côté
 * appelant — et les perdre emporterait le `Content-Type` d'un POST.
 */
export function apiFetch(
    input: Parameters<typeof fetch>[0],
    init: Parameters<typeof fetch>[1],
    locale: string,
): Promise<Response> {
    const headers = new Headers(init?.headers);
    headers.set(LOCALE_HEADER, locale);
    return fetch(input, { ...init, headers });
}
